import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const accountName = ({ accountName: _accountName }: VehicleStatsByCompany): string => _accountName || '--'
